/* eslint-disable */

<template>
  <div>
    <router-view />
    <!-- <div class="cookie_button consent-button" style="display: block">
      <button class="btn-cookie btn-transparent" @click.prevent="oneTrustModal">My Cookie Settings</button>
    </div> -->
  </div>
</template>
<script>
const version = process.env.VUE_APP_VERSION;

export default {
  created () {
    console.log("%cV" + version, "color:red; font-size:32px;");
  },
  methods: {
    oneTrustModal: function () {
      // eslint-disable-next-line no-undef
      Optanon.OnConsentChanged(() => {
        if (window.segmentaCookieHandler) window.segmentaCookieHandler();
        if (!window.nsId && !window.nsIdPending && window.nsUrl) {
          window.nsIdPending = true;
          // eslint-disable-next-line no-undef
          fetchJsonp(window.nsUrl, {
            jsonpCallbackFunction: "neustar_response"
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (json) {
              window.nsId = json.nsid;
            });

          if (window._agknEchoTag) {
            var a = window._agknEchoTag;
            a.setBpId("firstp");
            a.addEchoKeyValue("event", "page_landing");
            a.generateTag();
          }
        }
      });
      // eslint-disable-next-line
      Optanon.ToggleInfoDisplay();
    }
  }
};
</script>
<style lang="scss">

@import "~@/assets/styles/_application.scss";
@import "node_modules/bootstrap/scss/bootstrap";
@import "node_modules/bootstrap-vue/src/index.scss";
@media (min-width: 1440px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1270px !important;
  }
}


.cookie_button button {
  font-size: 14px;
  padding: 10px;
  border-radius: 3px;
  border: 1px solid #034c90;
  right: 0;
}

.cookie_button button:hover {
  color: #034c90;
  background: #fff;
}
.cookie_button {
  border-radius: 3px;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
  text-align: left;
  position: fixed;
  right: 0;
  z-index: 2;
  bottom: 0px;
  opacity: 0.9;
  background: #034c90;
  color: #000000;
  display: none;
  overflow: auto;
}
.cookie_button.open {
  display: block;
}
.btn-cookie {
  font-size: 20px;
  // letter-spacing: 1px;
  color: #000;
  transition: all 0.3s;
  white-space: normal;
  line-height: 1.36;
  text-align: center;
  padding: 9px 5px 9px;
  // text-transform: uppercase;
  border-radius: 0rem;
  border: none;
  line-height: 1;
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 1141px !important;
  }
}
</style>
